import { Dispatch, SetStateAction } from 'react';

import { numberToCurrency } from '@/utils/Formatter';
import { UseFormik } from '@/utils/Formik/types';

import { useGuestDamage } from '@/hooks/GuestDamage/useGuestDamage';

import FormButton from '@/components/FormButton/FormButton';
import { CopyLink } from '@/components/GuestDamage/components/CopyLink';
import ItemDamageForm from '@/components/GuestDamage/components/Forms/ItemDamageForm';

import {
  ButtonContainer,
  GridContainer,
  ItemDamageFormContainer,
  ItemDamageFormItem,
  LinkText,
} from './styles';

interface ItemDamageFormViewProps {
  formik: UseFormik<any>;
  quantity: number;
  setQuantity: Dispatch<SetStateAction<number>>;
  isEditingForm: boolean;
  setIsEditingForm: Dispatch<SetStateAction<boolean>>;
}

const ItemDamageFormView = ({
  formik,
  quantity,
  setQuantity,
  isEditingForm,
  setIsEditingForm,
}: ItemDamageFormViewProps) => {
  const { selectedGuestDamage, handleOpenFile } = useGuestDamage();
  return (
    <>
      {isEditingForm ? (
        <ItemDamageForm
          formik={formik}
          quantity={quantity}
          setQuantity={setQuantity}
          isEditingForm={isEditingForm}
        />
      ) : (
        <ItemDamageFormContainer
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.5 }}
          key="ItemDamageForm"
          transition={{
            duration: 0.4,
            ease: [0, 0.71, 0.2, 1.01],
          }}
        >
          <GridContainer>
            <ItemDamageFormItem>
              <h3>Classificação do dano</h3>
              <p>{selectedGuestDamage.item_type || '-'}</p>
            </ItemDamageFormItem>
            <ItemDamageFormItem>
              <h3>Qual item foi danificado ?</h3>
              <p>{selectedGuestDamage.item_name || '-'}</p>
            </ItemDamageFormItem>
            <ItemDamageFormItem>
              <h3>O que precisa ser feito?</h3>
              <p>{selectedGuestDamage.resolution || '-'}</p>
            </ItemDamageFormItem>
            <ItemDamageFormItem>
              <h3>Evidências</h3>
              {selectedGuestDamage.evidences && selectedGuestDamage?.evidences?.length > 0
                ? selectedGuestDamage.evidences?.map((evidence) => (
                    <LinkText
                      onClick={() =>
                        handleOpenFile(evidence.evidence?.url!, evidence.evidence?.name!)
                      }
                    >
                      {evidence.evidence?.name}
                    </LinkText>
                  ))
                : '-'}
            </ItemDamageFormItem>
            <ItemDamageFormItem>
              <h3>Valor</h3>
              <p>{numberToCurrency(selectedGuestDamage.item_price) || '-'}</p>
            </ItemDamageFormItem>
            <ItemDamageFormItem>
              <h3>Link do orçamento</h3>
              <CopyLink link={selectedGuestDamage.quotation_link} />
            </ItemDamageFormItem>
            <ItemDamageFormItem>
              <h3>Orçamento / Nota fiscal</h3>
              <LinkText
                onClick={() =>
                  handleOpenFile(
                    selectedGuestDamage.quotation_file?.url!,
                    selectedGuestDamage.quotation_file?.name!,
                  )
                }
              >
                {selectedGuestDamage.quotation_file?.name || '-'}
              </LinkText>
            </ItemDamageFormItem>
            <ItemDamageFormItem>
              <h3>Observações</h3>
              <p>{selectedGuestDamage.observation || '-'}</p>
            </ItemDamageFormItem>
          </GridContainer>
          <ButtonContainer>
            <FormButton onClick={() => setIsEditingForm(true)}>Editar item</FormButton>
          </ButtonContainer>
        </ItemDamageFormContainer>
      )}
    </>
  );
};

export default ItemDamageFormView;
